import React from 'react';
import { motion } from 'framer-motion';
import HeroStats from './hero/HeroStats';
import HeroContent from './hero/HeroContent';
import HeroBackground from './hero/HeroBackground';

interface HeroProps {
  onGetStarted: () => void;
}

export default function Hero({ onGetStarted }: HeroProps) {
  return (
    <div className="relative bg-gradient-to-b from-dark-lighter to-dark pt-32 sm:pt-28 md:pt-36 pb-12">
      <HeroBackground />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="flex items-center justify-center space-x-2 mb-6"
          >
            <HeroStats />
          </motion.div>
          
          <HeroContent onGetStarted={onGetStarted} />
        </div>
      </div>
    </div>
  );
}